// import http from "../../http";
// 新门店活动
const state = {
  curShop: null,
  // 新街口
  shopXjk: {
    citys: [3201],
    start: '2021/9/10', // 开始时间
    end: '2021/10/14', // 结束时间 零点
    popEnd: '2021/09/16', // 弹窗结束时间 零点
    close: '2021/10/21', // 活动所有入口（抽奖）关闭时间
    title: '新街口馆开业', // 活动标题
    sFromKey: 'shopXjk', // 渠道key
    sFromId: 129, // 渠道卡id
    rFromId: 72, // 渠道注册id
    shopId: 212, // 门店Id
    actId: 1012, // 活动Id
    actUrl: 'member/activity.NewStoreOpeningTwo',
    share: {
      // 分享信息
      title: '健萌新街口私教馆开业啦～最高立减3599元，快来一起锻炼吧~',
      desc: '专业1对1私教健身课，邀你来体验～',
      imgUrl: 'https://cdnvue.gymcity.com.cn/uploads/kl-share?v=3'
    },
    banner: 'https://cdnvue.gymcity.com.cn/uploads/kl-banner?v=4', // banner地址
    pop: 'https://cdnvue.gymcity.com.cn/uploads/kl-pop?v=4', // 弹窗地址
    indexTop:
      'https://cdnvue.gymcity.com.cn/uploads/f4248a9eaf806e05144024612c51fc95.png?v=2', // 活动主页上方bg
    indexBot: 'https://cdnvue.gymcity.com.cn/uploads/nshop-index-bot-bg?v=4', // 活动主页下方bg
    posterImg: 'https://cdnvue.gymcity.com.cn/uploads/kl-poster?v=4', // 海报背景图
    proTop: 'https://cdnvue.gymcity.com.cn/uploads/kl-top?v=4', // 进度页上方bg
    ruleBg: 'https://cdnvue.gymcity.com.cn/uploads/kl-rule-new?v=3', // 新用户规则页背景
    getBg: 'https://cdnvue.gymcity.com.cn/uploads/kl-get-bg?v=3', // 新用户领卡页背景
    location: {
      latitude: 32.041627, // 纬度，浮点数，范围为90 ~ -90
      longitude: 118.778761, // 经度，浮点数，范围为180 ~ -180。
      name: '新街口私教馆', // 位置名
      address: '南京市秦淮区汉中路89号金鹰国际购物中心B座7层b-7054商铺', // 地址详情说明
      scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
      infoUrl: location.href // 在查看位置界面底部显示的超链接,可点击跳转
    }
  },
  // 喜盈门
  shopXym: {
    citys: [4301],
    start: '2021/9/18', // 开始时间
    end: '2021/10/20', // 结束时间 零点
    popEnd: '2021/09/22', // 弹窗结束时间 零点
    close: '2021/10/26', // 活动所有入口（抽奖）关闭时间
    title: '喜盈门范城馆开业', // 活动标题
    sFromKey: 'shopXym', // 渠道key
    sFromId: 130, // 渠道卡id
    rFromId: 74, // 渠道注册id
    shopId: 213, // 门店Id
    actId: 1013, // 活动Id
    actUrl: 'member/activity.NewStoreOpeningThree',
    share: {
      // 分享信息
      title: '健萌喜盈门范城私教馆开业啦～最高立减3300元，快来一起锻炼吧~',
      desc: '专业1对1私教健身课，邀你来体验～',
      imgUrl: 'https://cdnvue.gymcity.com.cn/uploads/ns-xym-share'
    },
    banner: 'https://cdnvue.gymcity.com.cn/uploads/ns-xym-banner', // banner地址
    pop: 'https://cdnvue.gymcity.com.cn/uploads/ns-xym-shop', // 弹窗地址
    indexTop: '	https://cdnvue.gymcity.com.cn/uploads/ns-xym-i-top', // 活动主页上方bg
    indexBot: 'https://cdnvue.gymcity.com.cn/uploads/ns-xym-i-bot?v=1', // 活动主页下方bg
    proTop: 'https://cdnvue.gymcity.com.cn/uploads/ns-xym-pro-top', // 进度页上方bg
    ruleBg: 'https://cdnvue.gymcity.com.cn/uploads/ns-xym-rule', // 新用户规则页背景
    getBg: 'https://cdnvue.gymcity.com.cn/uploads/ns-xym-get-bg', // 新用户领卡页背景
    location: {
      latitude: 28.074518, // 纬度，浮点数，范围为90 ~ -90
      longitude: 113.01919, // 经度，浮点数，范围为180 ~ -180。
      name: '喜盈门范城私教馆', // 位置名
      address: '长沙市雨花区万家丽中路喜盈门范城街区5栋2楼', // 地址详情说明
      scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
      infoUrl: location.href // 在查看位置界面底部显示的超链接,可点击跳转
    }
  }
}
const mutations = {
  setNewShopCurShop(state, data) {
    state.curShop = data
  }
}
const getters = {
  // showNewShopXjk: state => {
  //   const now = new Date().getTime();
  //   return (
  //     now >= new Date(state.shopXjk.start).getTime() &&
  //     now < new Date(state.shopXjk.end).getTime()
  //   );
  // }
}
const actions = {}

export default {
  state,
  mutations,
  actions,
  getters
}
